import BigNumber from './BigNumber.js';
/**
 * @deprecated - use toHumanReadable instead
 */
export default class BigNumberInBase extends BigNumber {
    static make(number) {
        return new BigNumberInBase(number);
    }
    minus(n, base) {
        return new BigNumberInBase(super.minus(n, base));
    }
    plus(n, base) {
        return new BigNumberInBase(super.plus(n, base));
    }
    dividedBy(n, base) {
        return new BigNumberInBase(super.dividedBy(n, base));
    }
    div(n, base) {
        return new BigNumberInBase(super.div(n, base));
    }
    multipliedBy(n, base) {
        return new BigNumberInBase(super.multipliedBy(n, base));
    }
    times(n, base) {
        return new BigNumberInBase(super.times(n, base));
    }
    pow(n, base) {
        return new BigNumberInBase(super.pow(n, base));
    }
    toWei(decimals = 18) {
        return new BigNumber(this).multipliedBy(new BigNumber(10).pow(decimals));
    }
}
